/**
 * Copyright ©2025 Drivepoint
 */

import {Utilities} from "@bainbridge-growth/node-common";
import {Store} from "@bainbridge-growth/node-frontend";
import WebAppServerClient from "../clients/WebAppServerClient";
import State from "../state/State";
import {StateEvent} from "../state/StateEvent";

type DeductCreditsData = {
  credits_amount: number;
  feature_name: string;
};

export default class CreditsStore extends Store {

  private _company?: any;
  private _abortController: AbortController = new AbortController();

  init(): void {
    this.loading = true;
    State.register("company", (event: StateEvent) => {
      this.value = {};
      this._company = event.value;
      this.refresh();
    });
  }

  async refresh(timeout: number = 0): Promise<void> {
    if (!this._company) { return; }
    return this.action(async () => {
      if (timeout > 0) { await Utilities.sleep(timeout); }
      this._abortController?.abort();
      this._abortController = new AbortController();
      this.value = await WebAppServerClient.request(`/ui/company/${this._company?.id}/available_credits`, "GET", undefined, this._abortController);
    });
  }

  async requestCredits(purchaseValue: string, notes: string): Promise<void> {
    if (!this._company) { return; }
    await WebAppServerClient.request(`/ui/company/${this._company?.id}/purchase_credits`, "POST", {purchaseValue, notes});
  }

  async requestRedeemCredits(data: Record<string, any>): Promise<void> {
    if (!this._company) { return; }
    await WebAppServerClient.request(`/ui/company/${this._company?.id}/redeem_credits`, "POST", {...data});
  }

  async deductCredits(data: DeductCreditsData): Promise<void> {
    if (!this._company) { return; }
    await WebAppServerClient.request(`/ui/company/${this._company?.id}/use_credits`, "POST", {...data, platform: "webapp"});
  }

}
